import React from 'react';
import ColorPicker from './ColorPicker';
import ProgressSpinnerSmall from 'APP_ROOT/components/common/ProgressSpinnerSmall';
import PropTypes from 'prop-types';

import { strings } from 'APP_ROOT/localization';

export default class Color extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            displayColorPicker: false
        };
    }

    didTapValue = (event) => {

        event.stopPropagation(); // https://developer.mozilla.org/en-US/docs/Web/API/Event/stopPropagation

        /* development keep color picker onscreen if (this.state.displayColorPicker) {
            return;
        }*/
        this.setState({
            displayColorPicker: true
        });
    }

    onChange = (value) => {
        this.closeColorPicker();
        this.props.onChange(value);
    }

    closeColorPicker = () => {
        this.setState({
            displayColorPicker: false
        });
    }

    render () {

        let backgroundColor = 'transparent';

        if (this.props.value) {
            backgroundColor = this.props.value;
        }

        const showLabel = this.props.showLabel !== undefined ? this.props.showLabel : true;
        
        return (
            <section className="color">
                {showLabel && <h4 className="label">{strings.resource_color}</h4>}
                <button
                    className="value"
                    disabled={!this.props.editable}
                    style={{background: backgroundColor}}
                    onClick={this.didTapValue}
                >
                    {/* absolute positioned elements */}
                    {this.props.status === "PENDING" ?
                        <div className={"status-overlay"}>
                            <ProgressSpinnerSmall />
                        </div>
                        :
                        null
                    }
                    {this.state.displayColorPicker ?
                        <div className="color-picker">
                            <ColorPicker
                                parentElmSelector={this.props.parentElmSelector}
                                color={this.props.value}
                                colors={this.props.colors}
                                onChange={this.onChange}
                                onClose={this.closeColorPicker} // capture when ColorPicker closes itself
                            />
                        </div>
                        :
                        null
                    }
                </button>
            </section>
        )
    }
}

Color.propTypes = {
    value: PropTypes.string, // a CSS color value (HEX, RGBA, HSL (function notation) etc, https://developer.mozilla.org/en-US/docs/Web/CSS/color_value)
    status: PropTypes.string, 
    onChange: PropTypes.func.isRequired,
}

Color.defaultProps = {
    editable: true,
};